var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viewcustomizer__wrapper" }, [
    _c(
      "div",
      { staticClass: "viewcustomizer__wrapper--buttons" },
      _vm._l(_vm.views, function (view, index) {
        return _c(
          "button",
          {
            key: view + index,
            on: {
              click: function ($event) {
                _vm.activeView = index
              },
            },
          },
          [
            _c("img", {
              class: { active: _vm.activeView == index },
              attrs: {
                src: `${_vm.pluginPath}/icons/view/${view}.svg`,
                alt: _vm.$translate(
                  "TatyouTheme::Template.categoriesCustomizeView"
                ),
              },
            }),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(_vm.$translate("TatyouTheme::Template.categoriesCustomizeView"))
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }